// Lib
import { createAction } from '@reduxjs/toolkit';

export const Open2Modal = createAction('OPEN_2_MODAL');
export const Close2Modal = createAction('CLOSE_2_MODAL');
export const Clean2Modal = createAction('CLEAN_2_MODAL');
